var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1798_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.2 84.4395L117.546 86.7595L112.613 89.8928L112.2 84.4395Z",
    fill: "#B4875F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84 65.7461L117.173 68.0661L112.253 71.1861L111.84 65.7461Z",
    fill: "#B4875F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.373 46.8672L117.72 49.1872L112.786 52.3072L112.373 46.8672Z",
    fill: "#B4875F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6 87.9067L118.666 87.3067C120.253 87.8667 120.44 88.9601 119.173 89.6534L74.0664 114.987L2.33311 85.8401C-0.746886 79.4401 -0.746886 71.3601 2.15978 66.9734C0.724864 64.0191 0.00944887 60.7672 0.0720178 57.4835C0.134587 54.1998 0.973364 50.9775 2.51978 48.0801L53 21L117.72 49.1601L118.8 49.5201C119.533 49.9334 120.08 50.4801 119.893 50.8534C119.879 51.0845 119.806 51.3081 119.68 51.5021C119.553 51.6962 119.379 51.854 119.173 51.9601L115.173 54.2267C114.859 55.7917 114.623 57.3715 114.466 58.9601C114.106 62.4667 114.133 66.6667 115.573 69.3334L118.48 68.4401C119.933 68.9867 120.173 70.0801 118.84 70.8134L115.04 72.9867C114.74 74.7191 114.557 76.4697 114.493 78.2267C114.321 81.4925 114.695 84.7641 115.6 87.9067Z",
    fill: "#3C8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.853 112.933L115.56 87.9064C113.066 79.8664 115.4 70.973 115.4 70.973C115.574 70.7352 115.68 70.455 115.708 70.1617C115.737 69.8684 115.685 69.5729 115.56 69.3064C112.573 63.7597 115.56 52.2931 115.56 52.2931C115.636 51.6553 115.636 51.0108 115.56 50.373L71 74L71.853 112.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7064 96.1201L118.8 70.7867C120.133 70.0534 119.893 68.9601 118.44 68.4134L117.106 68.0401L72.2531 93.0001C71.4081 87.7367 70.2224 79.2222 72.2531 74.2934L2.51978 48.0801C0.973364 50.9775 0.134587 54.1998 0.072018 57.4835C0.00944909 60.7672 0.724864 64.0191 2.15978 66.9734L73.7064 96.1201ZM118.666 87.3067L117.573 86.7601L72.6131 112C71.7064 107.24 71.7064 100.64 73.7064 96.0001L2.15978 66.9734C-0.746886 71.3601 -0.746886 79.4401 2.33311 85.8401L74.0664 114.987L119.173 89.6534C120.44 88.9601 120.253 87.8667 118.666 87.3067Z",
    fill: "#2D6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15964 66.974C1.95888 67.306 1.77639 67.6487 1.61298 68.0007L73.7063 96.1206L1.46631 65.334C1.66657 65.8932 1.89804 66.4407 2.15964 66.974Z",
    fill: "#3BADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1798_2255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvance);
export default __webpack_public_path__ + "static/media/advance.0de0c2567c73428273a3ae3383abaf8d.svg";
export { ForwardRef as ReactComponent };